export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/sitebuilder.6e94ba5.svg";